import PeriodRequest from '@/app/models/sharingPMO';
import { useSharingResponseQuery } from '@/app/services/sharingRequestApi';
import { usePeriod } from '@/components/context/PeriodContext';
import PeriodDetails from '@/components/periodDetails/PeriodDetails';
import SearchResultOrigin from '@/components/searchBar/SearchResultOrigin';
import SharingPMOTable from '@/components/tables/SharingPMOTable';
import NewEditPeriodRequestScreen from '@/components/uploadFiles/newEditScreen/NewEditPeriodRequestScreen';
import { Box, Button, Drawer, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function PMOSharing() {
  const { t } = useTranslation(['pmo', 'common']);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(5);
  const [searchTerm, setSearchTerm] = useState('');

  const { selectedPeriod } = usePeriod();

  const { data } = useSharingResponseQuery(
    {
      searchTerm: searchTerm.toUpperCase() as string,
      periodDate: selectedPeriod?.date as string,
      page,
      size,
    },
    { skip: !selectedPeriod },
  );

  const [drawerStatus, setDrawerStatus] = useState(false);
  const [selectedItem, setSelectedItem] = useState<PeriodRequest | null>(null);

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginRight: '20px',
      }}
    >
      <PeriodDetails />
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          sx={{
            fontWeight: 'bold',
            fontSize: '18px',
            color: '#4b4b4b',
            marginTop: '32px',
          }}
        >
          {t('common:sharing.pmo')}
        </Typography>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '20%',
            margin: '0',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              height: '100%',
              pr: 3,
              marginTop: '0.5rem',
            }}
          >
            <Box display="flex" flexDirection="row">
              <Button
                onClick={() => {
                  setSelectedItem(null);
                  setDrawerStatus(true);
                }}
                variant="text"
                sx={{
                  color: '#f97c06',
                  textTransform: 'none',
                  fontWeight: 800,
                  fontSize: 14,
                }}
              >
                {` + ${t('common:import.file')}`}
              </Button>
            </Box>
          </Box>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: '2.5rem',
            width: '70%',
            marginBottom: '15px',
          }}
        >
          <SearchResultOrigin searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '2rem',
          width: '100%',
        }}
      >
        <SharingPMOTable
          rows={data?.content || []}
          count={data?.totalElements as number}
          page={page}
          setPage={setPage}
          rowsPerPage={size}
          setRowsPerPage={setSize}
        />
      </div>
      <Drawer
        anchor="right"
        open={drawerStatus}
        onClose={(event: React.SyntheticEvent, reason: string) => {
          setDrawerStatus(false);
        }}
      >
        <NewEditPeriodRequestScreen periodRequest={selectedItem} setDrawerOpen={setDrawerStatus} />
      </Drawer>
    </div>
  );
}
export default PMOSharing;
